import * as os from 'node:os';
import * as path from 'node:path';

const isWindows = os.platform() === 'win32';

export const isAbsolute = isWindows
  ? path.win32.isAbsolute
  : path.posix.isAbsolute;

/** Only call this on normalized paths */
export const join = path.posix.join;

/** Only call this on normalized paths */
export const relative = path.posix.relative;

/** Only call this on normalized paths */
export const basename = path.posix.basename;

export { dirname } from 'node:path';
